var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-marker',{ref:"marker",attrs:{"position":_vm.location,"clickable":true,"draggable":_vm.drawMode === 'move',"icon":_vm.markerIcon},on:{"click":_vm.onMarkerClicked,"dragend":_vm.updateCoordinates,"mousedown":_vm.mouseDown,"mouseup":_vm.mouseUp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }